import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import ROUTES from "constants/routes";

const PAGES = [
  { title: "Карты компетенций", link: `/${ROUTES.COMPETENCE_MAPS}` },
  // TODO: завершить скрытие страницы
  // { title: "Блоки знаний", link: `/${ROUTES.KNOWLEDGE_BLOCKS}` },
  { title: "Тестирования", link: `/${ROUTES.TESTING}` },
  { title: "Кандидаты", link: `/${ROUTES.CANDIDATE}` },
  { title: "Вакансии", link: `/${ROUTES.VACANCIES}` },
  { title: "Моя компания", link: `/${ROUTES.COMPANY}` },
];

const Navigation = ({ isAuth }: { isAuth: boolean }) => {
  const location = useLocation();
  // TODO integrate isDirector
  // const isDirector = isAuth;

  return (
    <>
      {isAuth &&
        PAGES.map((page) => {
          const isCurrentPage = location.pathname.includes(page.link);
          return (
            <Button
              color='secondary'
              size='medium'
              disableRipple
              key={page.link}
              sx={{
                paddingX: 1,
                wordBreak: "normal",
                pb: 0,
                ...(isCurrentPage && { color: "primary.dark" }),
              }}
              component={Link}
              to={page.link}>
              {page.title}
            </Button>
          );
        })}
      {/* TODO: может, в последствии понадобится оформлять некоторые линки в отдельный stack, но пока не неужно */}
      {/* {isDirector && (
        <Stack
          direction='row'
          alignItems='center'>
          <Button
            color='secondary'
            size='medium'
            disableRipple
            sx={{
              paddingX: 1,
              ...(location.pathname.includes(ROUTES.COMPANY) && { color: "primary.dark" }),
            }}
            component={Link}
            to={`/${ROUTES.COMPANY}`}>
            Моя компания
          </Button>
        </Stack>
      )} */}
    </>
  );
};

export default Navigation;
